module.exports = __webpack_public_path__ + "static/media/mobile-footer.163bedf3.png";